'use strict';

export default {
	init : function () {
	$('.store-details-link').on('click', function (e) {
		e.preventDefault();
	});
}
};
